import { ReactNode, useMemo } from 'react';

import { FctReport, RadiologistScanDetail, User } from '@/api';
import { BroadcastChannelProvider } from '@/core/broadcast-channel';

import { StudyGuardContext } from './study-guard.context';
import { StudyGuardState } from './study-guard.model';

export interface StudyGuardProviderProps {
  children: ReactNode;
  patient: User;
  radiologistScan: RadiologistScanDetail;
  report?: FctReport;
  studyId: string;
}

export function StudyGuardProvider({
  children,
  patient,
  radiologistScan,
  report,
  studyId,
}: StudyGuardProviderProps) {
  const isPoetryStudy = radiologistScan.skuID === '900';

  const value: StudyGuardState = useMemo(
    () => ({ isPoetryStudy, patient, radiologistScan, report, studyId }),
    [isPoetryStudy, radiologistScan, studyId, patient, report],
  );

  return (
    <StudyGuardContext value={value}>
      <BroadcastChannelProvider studyId={studyId}>{children}</BroadcastChannelProvider>
    </StudyGuardContext>
  );
}
